
import { LoadingState } from "@/components/LoadingState";
import { SearchAndFilter } from "@/components/SearchAndFilter";
import { Contractor, ViewMode } from "@/types/contractor";
import { useState } from "react";
import { ContractorsGrid } from "./contractors-list/ContractorsGrid";
import { PaginationControls } from "./contractors-list/PaginationControls";
import { FilterHeader } from "./contractors-list/FilterHeader";
import { NoResults } from "./contractors-list/NoResults";

interface ContractorsListProps {
  contractors: Contractor[];
  isLoading: boolean;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  onServiceTypeChange: (type: string) => void;
  onLocationChange?: (location: string) => void;
  selectedServiceType?: string;
}

export const ContractorsList = ({
  contractors,
  isLoading,
  viewMode,
  onViewModeChange,
  onServiceTypeChange,
  onLocationChange,
  selectedServiceType = 'all',
}: ContractorsListProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const contractorsPerPage = 12; // Changed from 8 to 12 (4x3 grid)
  
  // Calculate pagination values
  const totalPages = Math.ceil(contractors.length / contractorsPerPage);
  const startIndex = (currentPage - 1) * contractorsPerPage;
  const endIndex = startIndex + contractorsPerPage;
  const currentContractors = contractors.slice(startIndex, endIndex);

  console.log('ContractorsList rendering with:', {
    totalContractors: contractors.length,
    currentPage,
    totalPages,
    contractorsShowing: `${startIndex + 1}-${Math.min(endIndex, contractors.length)}`,
    selectedServiceType
  });

  return (
    <div className="w-full space-y-8">
      <FilterHeader selectedServiceType={selectedServiceType} />

      <SearchAndFilter
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        onServiceTypeChange={onServiceTypeChange}
        onLocationChange={onLocationChange}
        selectedServiceType={selectedServiceType}
      />

      {isLoading ? (
        <LoadingState />
      ) : currentContractors.length === 0 ? (
        <NoResults onClearFilters={() => onServiceTypeChange('all')} />
      ) : (
        <>
          <div className="text-sm text-muted-foreground mb-4">
            Showing {startIndex + 1}-{Math.min(endIndex, contractors.length)} of {contractors.length} contractors
          </div>
          
          <ContractorsGrid 
            contractors={currentContractors}
            viewMode={viewMode}
          />

          {totalPages > 1 && (
            <div className="mt-8">
              <PaginationControls
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
